import CatchError from '@/components/system/CacthError';
// export const runtime = 'experimental-edge';

export const TGReward = () => {
  return (
    <div>
      <h1>Reward Coming Soon...</h1>
    </div>
  );
};
export default CatchError(TGReward);
